import { useEffect } from "react";
import { useLocation } from "wouter";
import { useSyncError } from "../db/DatabaseProvider";
import { Routes } from "../routing";

export function SyncErrorHandler() {
	const { hasFatalError } = useSyncError();
	const [location, navigate] = useLocation();

	useEffect(() => {
		if (hasFatalError && location !== Routes.error) {
			navigate(Routes.error);
		}
	}, [hasFatalError, location, navigate]);

	return null;
}
